import { render, staticRenderFns } from "./LegalBasisTable.vue?vue&type=template&id=b7b58574&"
import script from "./LegalBasisTable.vue?vue&type=script&lang=js&"
export * from "./LegalBasisTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports